import React from 'react';
import type { FC } from 'react';
import { Grid } from '@alfa-bank/site-grid-universal';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import type { TextDesktop } from '@alfa-bank/site-text-v2/desktop';
import type { TextMobile } from '@alfa-bank/site-text-v2/mobile';

import type { TCatalogCardDesktop } from '../models';
type TBenefitsContent = Pick<
    TCatalogCardDesktop,
    | 'buttonText'
    | 'detailText'
    | 'floatImg'
    | 'giftImgAlt'
    | 'giftImgHeight'
    | 'giftImgSrc'
    | 'giftText'
> & {
    Text: typeof TextDesktop | typeof TextMobile;
    button: JSX.Element;
    detailButton: JSX.Element;
    newThemeNaming: 'light' | 'dark';
};

export const BenefitsContent: FC<TBenefitsContent> = ({
    Text,
    button,
    buttonText,
    detailButton,
    detailText,
    giftImgAlt,
    giftImgHeight = 10,
    giftImgSrc,
    giftText,
    newThemeNaming,
}) => {
    const FULL_WIDTH = 1;
    const COLUMN_WIDTH = 230;
    const MARGIN_BETWEEN_COLUMN = 32;
    const GIFT_ICON_WIDTH = 24;
    const GIFT_ICON_MARGIN = 12;
    const TWO_COLUMN_WIDTH = COLUMN_WIDTH * 2 + MARGIN_BETWEEN_COLUMN;

    const getBenefitsWidth = (width1: number, width2: number, width3: number) => {
        const isSomeButtonsUnavailable = !buttonText || !detailText;
        const isBothButtonsUnavailable = !buttonText && !detailText;

        if (isBothButtonsUnavailable) {
            return width1;
        }
        if (isSomeButtonsUnavailable) {
            return width2;
        }

        return width3;
    };

    return (
        <Grid
            collapse
            columnsWidth={[
                getBenefitsWidth(FULL_WIDTH, TWO_COLUMN_WIDTH, COLUMN_WIDTH),
                detailText ? MARGIN_BETWEEN_COLUMN : '0px',
                detailText ? COLUMN_WIDTH : '0px',
                MARGIN_BETWEEN_COLUMN,
                buttonText ? COLUMN_WIDTH : '0px',
            ]}
            justify="start"
        >
            <Grid
                collapse
                columnsWidth={[
                    giftImgSrc ? GIFT_ICON_WIDTH : '0px',
                    giftImgSrc ? GIFT_ICON_MARGIN : '0px',
                    getBenefitsWidth(
                        FULL_WIDTH,
                        TWO_COLUMN_WIDTH - GIFT_ICON_WIDTH - GIFT_ICON_MARGIN,
                        COLUMN_WIDTH - GIFT_ICON_WIDTH - GIFT_ICON_MARGIN
                    ),
                ]}
                justify="start"
            >
                <>
                    {giftImgSrc && (
                        <Img alt={giftImgAlt} height={giftImgHeight} src={giftImgSrc} width={24} />
                    )}
                </>
                <></>
                <>
                    <Text
                        styler={{ margin: 0, padding: 0 }}
                        theme={newThemeNaming}
                        view="primary-medium"
                    >
                        {giftText}
                    </Text>
                </>
            </Grid>
            <></>
            <div>{detailText && detailButton}</div>
            <></>
            <div>{buttonText && button}</div>
        </Grid>
    );
};
